<template>
	<v-app>

		<v-navigation-drawer
			:clipped="$vuetify.breakpoint.lgAndUp"
			v-model="drawer"
			fixed
			app
		>
		
			<v-list class="pa-1">
				<v-list-tile v-if="user.user_id">

					<v-list-tile-content>
						<v-list-tile-title>User: {{user.handle || user.user_id}}</v-list-tile-title>
					</v-list-tile-content>
					
					<v-list-tile-action v-if="false">
						<v-btn flat icon title="Settings">
							<v-icon small>fa-cog</v-icon>
						</v-btn>
					</v-list-tile-action>
					<v-list-tile-action>
						<v-btn flat icon title="Log out" @click="logout">
							<v-icon small>fa-sign-out-alt</v-icon>
						</v-btn>
					</v-list-tile-action>
				</v-list-tile>
				
				<v-list-tile v-else>
					<v-list-tile-action>
						<v-btn flat @click="showLoginDialog">
							Log in
						</v-btn>
					</v-list-tile-action>
					
					<v-list-tile-action>
						<v-btn flat @click="showRegisterDialog">
							Register
						</v-btn>
					</v-list-tile-action>
				</v-list-tile>
			</v-list>

			<v-list dense class="pa-0">
				<v-divider></v-divider>
				
				<v-layout row>
				<v-flex xs12>
				<v-tabs
				v-model="currentTab"
				grow
				>
					<v-tab>
						<v-icon flat small>fa-map</v-icon>
					</v-tab>
					
					<!-- TODO
					<v-tab>
						<v-icon flat small>fa-chart-area</v-icon>
					</v-tab>
					-->
					
					<v-tab>
						<v-icon flat small>fa-table</v-icon>
					</v-tab>
				</v-tabs>
				</v-flex>
				</v-layout>
				
				<v-divider></v-divider>
				
				<v-btn flat small @click="showTokenDialog" v-if="isLoggedIn">
					<v-icon small>add</v-icon>
					<small>
						New channel
					</small>
				</v-btn>
				
				<follow-token-list>
				</follow-token-list>
			</v-list>
		</v-navigation-drawer>

		<v-content>
			<router-view></router-view>
			<v-btn
				class="transparent"
				style="z-index:100"
				small
				fixed
				bottom
				left
				fab
				@click="drawer = !drawer"
			>
				<v-icon color="secondary lighten-3" style="height:auto">fa-angle-double-{{drawer? "left" : "right"}}</v-icon>
			</v-btn>
		</v-content>
		
		<v-snackbar
		v-model="snackbar.shown"
		top
		:color="snackbar.color || 'info'"
		:timeout="snackbar.timeout === undefined ? 6000 : snackbar.timeout"
		:multi-line="true">
			{{ snackbar.message }}
			
			<v-btn small flat @click="snackbar.shown = false">Close</v-btn>
		</v-snackbar>
		
		<follow-confirm-yes-no
		:show="dialogue.confirmYesNo"
		v-on:hide="dialogue.confirmYesNo = false" />
		
		<follow-registration :show="dialogue.register" v-on:hide="dialogue.register = false"></follow-registration>
		
		<follow-login :show="dialogue.login" v-on:hide="dialogue.login = false"></follow-login>
		
		<follow-token-info
		:show="dialogue.tokenInfo"
		v-on:hide="dialogue.tokenInfo = false"
		></follow-token-info>
		
		<follow-token-edit
		:show="user.user_id && dialogue.tokenEdit"
		v-on:hide="dialogue.tokenEdit = false"
		></follow-token-edit>
		
		<follow-token-share
		:show="user.user_id && dialogue.tokenShare"
		v-on:hide="dialogue.tokenShare = false"
		></follow-token-share>
		
		<follow-recording-options
		:show="user.user_id && dialogue.recordingOptions"
		v-on:hide="dialogue.recordingOptions = false"
		></follow-recording-options>
		
		<follow-scripting :show="dialogue.scripting" v-on:hide="dialogue.scripting = false" />
		
	</v-app>
</template>

<style lang="stylus">
html
	height 100%
body
	height 100%
</style>

<script>
import '@fortawesome/fontawesome-free/css/all.css'
import FollowConfirmYesNo from './components/dialogues/ConfirmYesNo'
import FollowRegistration from './components/dialogues/Registration'
import FollowLogin from './components/dialogues/Login'
import FollowTokenInfo from './components/dialogues/TokenInfo'
import FollowTokenEdit from './components/dialogues/TokenEdit'
import FollowTokenShare from './components/dialogues/TokenShare'
import FollowScripting from './components/dialogues/Scripting'
import FollowTokenList from './components/partials/TokenList'
import FollowRecordingOptions from './components/dialogues/RecordingOptions'
import FollowMap from './components/Map'

import api from './assets/js/api-instance'

import Vue from 'vue'
import Vuex from 'vuex'
import Vuetify from 'vuetify'

Vue.use(Vuetify, {
	iconfont: 'fa'
});

export default {
	name: 'App',
	
	components: {
		FollowConfirmYesNo,
		FollowRegistration,
		FollowLogin,
		FollowTokenInfo,
		FollowTokenEdit,
		FollowTokenShare,
		FollowScripting,
		FollowTokenList,
		FollowRecordingOptions,
		FollowMap
	},
	
	data () {
		return {
			drawer: null,
			dialogue: {
				confirmYesNo: false,
				register: false,
				login: false,
				tokenEdit: false,
				tokenShare: false,
				tokenInfo: false,
				scripting: false,
				recordingOptions: false
			},
			snackbar: { shown: false },
			currentTab: 0,
		}
	},
	
	watch: {
		currentTab (selected) {
			const tabs = ["map", /* TODO "graph",*/ "table"];
			this.$store.commit('setCurrentView', tabs[selected]);
		}
	},
	
	computed: {
		user () {
			return this.$store.state.userData;
		},
		
		isLoggedIn () {
			return !!this.user.user_id;
		},
		
		isRecording () {
			return Object.values(this.$store.state.tokenData.tokenState || {})
			.some( token => token.recording );
		}
	},
	
	methods: {
		async logout () {
			await api.logout();
			await this.$store.dispatch('logout');
		},
		
		showLoginDialog () {
			this.dialogue.login = true;
		},
		
		showRegisterDialog () {
			this.dialogue.register = true;
		},
		
		showTokenDialog () {
			this.dialogue.tokenEdit = true;
		},
		
		record () {
			this.dialogue.recordingOptions = true;
			//this.isRecording = !this.isRecording;
		}
	},
	
	async created () {
		this.$root.$on('dialogue', (payload) => {
			console.log("DIALOGUE EVENT RECEIVED", payload);
			this.dialogue = Object.assign({}, this.dialogue, payload);
		});
		
		this.$root.$on('snackbar', (payload) => {
			console.log("SNACKBAR EVENT RECEIVED", payload);
			this.snackbar = Object.assign({
				shown: true,
				color: "info",
				timeout: 6000,
			}, typeof payload === 'object' ? payload : {message: payload});
		});
		
		this.$root.$on('error', (payload) => {
			this.$root.$emit('snackbar', {
				color: "error",
				message: payload.message || payload
			});
		});
		
		api.eventTarget = document;
		api.eventTarget.addEventListener('follow-message', (event) => {
			console.log("ROOT", event);
			this.$root.$emit('message', event.detail);
		});
		api.eventTarget.addEventListener('follow-error', (event) => {
			console.log("ROOT", event);
			this.$root.$emit('error', event.detail);
		});
		
		await this.$store.dispatch('initSubscriptionHandlers');
		await this.$store.dispatch('restore');
		
		const tokens = String(this.$route.params.tokens || "")
			.split(";")
			.map(t => t.trim())
			.filter(t => !!t);
			
		for (const token of tokens) {
			this.$store.dispatch('setTokenVisible', {token, visible: true});
		}
	}
}
</script>
